import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React from "react";

const SmsoptModal = ({ hide, visible }) => {
  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            width: "100%",
          }}
        >
          {/* <span className="text-[#000833] text-[15px] mr-[12%] md:mr-[40%]">
            SMS Terms and Conditions
          </span> */}
          <Button
            type="text"
            icon={<CloseOutlined className="text-[20px]" />}
            onClick={hide}
          />
        </div>
      }
      open={visible}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="profile-modal"
      closeIcon={null}
      footer={null}
      bodyStyle={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <div className="space-y-4 text-[14px] leading-7 text-[#333]">
        <div className="font-bold text-[20px] text-black">
          Enrollment in AdvantEdge™ Platform, Services, and Communications
          Authorization
        </div>

        <div className="font-bold text-[16px]">
          Enrollment in AdvantEdge™ Platform and Services
        </div>

        <p>
          In connection with participation in programs, products, services,
          purchasing arrangements, compliance solutions, technology offerings,
          account relationships, or business services provided by a
          participating organization, wholesaler, buying group, pharmacy
          services administrative organization (“PSAO”), group purchasing
          organization (“GPO”), association, manufacturer, vendor, healthcare
          organization, strategic partner, or other participating entity (each,
          a “Client Organization”), participating pharmacies, businesses,
          organizations, customers, users, and account holders (each, a
          “Participant”) may be enrolled in or granted access to the AdvantEdge™
          platform and related products, progra. ogies, tools, features,
          communications, and services offered by AdvantEdge Holdings, LLC
          and/or its affiliates, subsidiaries, strategic partners, contractors,
          vendors, licensors, service providers, and related entities
          (collectively, “AdvantEdge Services”).
        </p>

        <p>
          For purposes of this Agreement, “AdvantEdge Services” shall be broadly
          construed to include any current or future products, services,
          technologies, solutions, software, applications, communication
          systems, analytics tools, dashboards, automation tools, artificial
          intelligence (“AI”) systems, purchasing solutions, procurement tools,
          compliance programs, workflow management tools, credentialing
          services, rebate administration, reporting tools, educational
          offerings, financial tools, account administration functions,
          operational support services, business intelligence tools, customer
          relationship management systems, security services, integrations,
          enhancements, modules, or related services made available now or in
          the future by or through AdvantEdge Holdings, LLC or affiliated
          entities.
        </p>

        <p>
          This authorization applies to the Participant and its owners,
          officers, directors, pharmacists, employees, contractors, agents,
          consultants, delegated administrators, representatives, users, account
          managers, and other individuals authorized to access or act on behalf
          of the Participant (collectively, “Authorized Representatives”).
        </p>

        <div className="font-bold text-[16px]">
          Consent to Receive Electronic Communications
        </div>

        <p>
          By providing, submitting, maintaining, updating, or otherwise
          permitting the use of any telephone number (including mobile telephone
          numbers), email address, or other contact information in connection
          with enrollment, onboarding, participation, account registration,
          service activation, purchasing activity, compliance administration,
          support requests, credentialing, account management, or use of
          AdvantEdge Services, the Participant, on behalf of itself and its
          Authorized Representatives, expressly consents and authorizes
          AdvantEdge Holdings, LLC, its affiliates, Client Organizations,
          contractors, communication vendors, service providers, platform
          partners, and authorized designees to contact the Participant and its
          Authorized Representatives through SMS/text message, email, telephone
          call, push notification, automated messaging systems, artificial
          intelligence (“AI”)-enabled communication tools, prerecorded or
          artificial voice technology (where legally permissible), chat
          functionality, and other electronic communication methods, including
          communications delivered using automatic telephone dialing systems
          (“ATDS”), automated technologies, workflow automation systems,
          predictive technologies, or AI-assisted communication systems where
          permitted by applicable law
        </p>

        <p>
          Communications may be sent for operational, transactional,
          informational, compliance, relationship management, educational,
          service-related, purchasing-related, financial, account management,
          security, support, and marketing or promotional purposes, including:
        </p>

        <ul className="list-disc pl-8 space-y-2">
          <li>Participation in AdvantEdge Services</li>
          <li>
            Client Organization programs, benefits, purchasing opportunities, or
            partnerships
          </li>
          <li>
            Product offerings, pricing opportunities, rebates, promotions,
            discounts, and incentives
          </li>
          <li>
            Account administration, onboarding, enrollment, renewals, and
            credentialing
          </li>
          <li>
            Compliance monitoring, audit requests, reporting obligations, and
            regulatory updates
          </li>
          <li>
            Technology updates, software enhancements, new features,
            integrations, or service changes
          </li>
          <li>
            Educational content, training, webinars, conferences, and events
          </li>
          <li>
            Customer support, account servicing, surveys, and relationship
            management
          </li>
          <li>
            Billing, invoices, payments, financial reconciliation, and
            purchasing activity
          </li>
          <li>
            Security alerts, fraud prevention, authentication, and account
            protection
          </li>
        </ul>

        <p>
          Consent to receive communications is not a condition of purchasing
          goods or services, except to the extent certain transactional,
          operational, legal, compliance, or security-related communications are
          necessary to administer accounts, maintain platform access, fulfill
          contractual obligations, deliver services, or protect account
          integrity.
        </p>
        <p>
          The Participant represents and warrants that it has obtained all
          necessary authority, permissions, notices, and consents required to
          provide contact information for Authorized Representatives and
          authorize communications relating to participation in AdvantEdge
          Services and associated Client Organization programs.
        </p>

        <div className="font-bold text-[16px]">
          Future Services and Flexibility
        </div>

        <p>
          Participant acknowledges and agrees that AdvantEdge Services may
          evolve over time and may include additional services, technologies,
          products, communication methods, integrations, affiliates,
          partnerships, or capabilities not currently offered or specifically
          identified herein. This authorization shall apply to all current and
          future AdvantEdge Services and associated communications unless
          otherwise prohibited by applicable law.
        </p>

        <div className="font-bold text-[16px]">Email Communications</div>

        <p>
          By providing an email address in connection with participation in
          AdvantEdge Services or a Client Organization program, the Participant
          and its Authorized Representatives consent to receive commercial
          electronic mail messages, newsletters, operational updates,
          promotional communications, service announcements, account notices,
          and transactional emails from or on behalf of AdvantEdge Holdings,
          LLC, Client Organizations, affiliated entities, strategic partners,
          vendors, contractors, and authorized service providers, in compliance
          with applicable law, including the CAN-SPAM Act and applicable state
          privacy and electronic communications laws.
        </p>
        <p>
          Email communications may include operational notices, purchasing
          opportunities, product and service offerings, educational materials,
          rebate opportunities, compliance reminders, training opportunities,
          webinar invitations, event announcements, platform enhancements,
          software releases, business opportunities, relationship management
          communications, and marketing or promotional content related to
          AdvantEdge Services or Client Organization programs.
        </p>
        <p>
          Participants may opt out of marketing or promotional email
          communications at any time by using the unsubscribe mechanism included
          in such communications or by contacting the applicable Client
          Organization or Member Services. Opting out of marketing emails shall
          not prevent delivery of transactional, legal, billing, security,
          compliance, account administration, operational, or service-related
          communications necessary to maintain participation, administer
          services, protect accounts, or fulfill contractual obligations.
        </p>

        <div className="font-bold text-[16px]">
          SMS/Text Messaging Communications
        </div>

        <p>
          SMS/text messaging communications may be used to facilitate account
          administration, operational efficiency, purchasing participation,
          compliance obligations, customer support, account servicing,
          relationship management, and delivery of important information related
          to participation in AdvantEdge Services or Client Organization
          programs.
        </p>
        <p>SMS/text communications may include, without limitation:</p>
        <ul className="list-disc pl-8 space-y-2">
          <li>Account notifications and onboarding updates </li>
          <li>Purchasing, pricing, rebate, and procurement alerts; </li>
          <li>
            Compliance reminders, audit requests, credentialing notifications,
            and regulatory updates;{" "}
          </li>
          <li>
            Billing, payment, invoice, reconciliation, and financial
            communications;{" "}
          </li>
          <li>
            Security alerts, authentication requests, fraud prevention, and
            account protection notifications;{" "}
          </li>
          <li>
            Educational content, webinar invitations, event reminders, and
            training opportunities;{" "}
          </li>
          <li>
            Customer service, account servicing, support responses, and
            satisfaction surveys;{" "}
          </li>
          <li>
            Product announcements, new features, software enhancements,
            integrations, and service updates; and{" "}
          </li>
          <li>
            Marketing, promotional, and relationship management communications
            regarding Client Organization offerings, partnerships, AdvantEdge
            Services, or related products and services.{" "}
          </li>
        </ul>
        <p>
          Certain SMS/text communications may be delivered using automated
          technologies, automatic telephone dialing systems (“ATDS”),
          AI-assisted messaging systems, workflow automation, predictive
          communication tools, or prerecorded/artificial voice technologies
          where legally permissible.
        </p>

        <div className="font-bold text-[16px]">
          Artificial Intelligence and Automated Technologies
        </div>

        <p>
          Participant acknowledges and agrees that communications, workflows,
          account servicing, analytics, support functions, compliance
          monitoring, purchasing support, customer engagement, fraud detection,
          and service optimization may involve the use of artificial
          intelligence (“AI”), machine learning technologies, predictive
          analytics, automation systems, virtual support tools, intelligent
          workflow systems, natural language processing technologies, and
          related automated technologies.
        </p>

        <p>
          Communications may be generated, facilitated, prioritized, routed,
          summarized, or delivered using AI-enabled systems to improve
          communication quality, responsiveness, operational efficiency,
          personalization, fraud prevention, support accuracy, and Member or
          customer experience.
        </p>

        <p>
          AdvantEdge Holdings, LLC and participating Client Organizations
          maintain commercially reasonable oversight, administrative safeguards,
          and contractual protections with vendors and service providers
          designed to protect Participant information and comply with applicable
          privacy and security obligations.
        </p>

        <div className="font-bold text-[16px]">Message Frequency</div>

        <p>
          Message frequency may vary based on account activity, purchasing
          participation, support interactions, platform usage, credentialing
          requirements, compliance obligations, regulatory developments,
          marketing preferences, account status, security events, Client
          Organization participation, and use of AdvantEdge Services.
          Participants and Authorized Representatives may receive recurring,
          periodic, triggered, or event-based communications.
        </p>

        <div className="font-bold text-[16px]">Message and Data Rates</div>

        <p>
          Standard message and data rates may apply to communications received
          through SMS/text messaging or other mobile communication channels.
          AdvantEdge Holdings, LLC, participating Client Organizations, and
          affiliated entities shall not be responsible for charges imposed by
          wireless carriers, internet service providers, or telecommunications
          providers. Participants remain solely responsible for charges
          associated with their communications plans or services.
        </p>

        <div className="font-bold text-[16px]">
          Opt-Out Rights and Communication Preferences
        </div>

        <p>
          Participants and Authorized Representatives may revoke consent or opt
          out of non-essential promotional or marketing communications at any
          time, subject to applicable law, by:
        </p>

        <ul className="list-disc pl-8 space-y-2">
          <li>Replying STOP to SMS/text communications;</li>
          <li>Replying HELP for support or assistance information;</li>
          <li>
            Clicking an unsubscribe link included in email communications;
          </li>
          <li>
            Updating communication preferences through an available account
            portal, profile, or platform settings; or
          </li>
          <li>
            Contacting AdvantEdge Holdings, LLC, the applicable Client
            Organization, or designated support personnel in writing or
            electronically.
          </li>
        </ul>

        <p>
          Opt-out requests shall be processed within a commercially reasonable
          timeframe and in accordance with applicable legal and carrier
          requirements.
        </p>

        <p>
          Revocation of consent for marketing communications shall not prohibit
          or limit necessary transactional, legal, operational, security,
          fraud-prevention, billing, purchasing, account administration,
          contractual, regulatory, compliance, or service-related communications
          reasonably required to administer participation, maintain account
          access, fulfill contractual obligations, or protect Participant
          interests.
        </p>

        <p>
          Withdrawal of consent shall not affect the validity or lawfulness of
          communications previously sent in reliance on prior consent.
        </p>

        <div className="font-bold text-[16px]">Privacy and Data Use</div>

        <p>
          Telephone numbers, email addresses, account information, communication
          preferences, usage data, and related information collected in
          connection with participation in AdvantEdge Services or Client
          Organization programs shall be collected, processed, maintained, and
          used in accordance with applicable privacy laws, contractual
          obligations, and published privacy policies.
        </p>

        <p>
          Contact information shall not be sold to unaffiliated third parties
          for their independent marketing purposes. However, Participant
          acknowledges that AdvantEdge Holdings, LLC and Client Organizations
          may share information with affiliates, contractors, vendors, platform
          providers, cloud service providers, communication vendors, analytics
          providers, customer relationship management providers, marketing
          automation providers, payment processors, consultants, auditors, legal
          counsel, and authorized service providers as reasonably necessary to
          administer services, support operations, facilitate communications,
          provide customer support, comply with legal obligations, improve
          services, and conduct legitimate business activities, subject to
          commercially reasonable confidentiality and data protection
          safeguards.
        </p>

        <div className="font-bold text-[16px]">
          Governing Law and Regulatory Compliance
        </div>

        <p>
          This Communications Authorization and Disclosure shall be governed by
          and construed in accordance with all applicable federal, state, and
          local laws, rules, and regulations, including, where applicable, the
          Telephone Consumer Protection Act (“TCPA”), 47 U.S.C. § 227; CAN-SPAM
          Act; Federal Communications Commission (“FCC”) regulations; Federal
          Trade Commission (“FTC”) regulations; CTIA messaging principles and
          carrier requirements; state telemarketing, privacy, biometric, and
          consumer protection laws; and other applicable data protection and
          communications regulations.
        </p>

        <p>
          AdvantEdge Holdings, LLC and participating Client Organizations may
          maintain records of consent, opt-in status, communication preferences,
          opt-out requests, account activity, and related communications to
          demonstrate compliance with applicable legal requirements.
        </p>

        <p>
          If any provision of this disclosure is deemed invalid, unenforceable,
          or inconsistent with applicable law, such provision shall be
          interpreted to the maximum extent permissible, and the remaining
          provisions shall remain in full force and effect.
        </p>
      </div>
    </Modal>
  );
};

export default SmsoptModal;
